export default __webpack_public_path__ + "static/buildupring-b51a81469534c031c46e6be477125aff.png";